import { useSelector } from "react-redux";
import NavbarHamburger from "./NavbarHamburgerMenu";
import NavbarLogo from "./NavbarLogo";
import NavbarNotificationBell from "./NavbarNotificationBell";
import NavbarInstagramButton from "./NavbarInstagramButton";

const TopNavbar = () => {
  const colorCode = useSelector(
    (state: any) => state.shopInfo.shopInfoData.colorCode,
  );
  const isMobileWidth = window.innerWidth < 768;
  return (
    <div
      className={`fixed z-20 top-0 left-0 right-0 h-16 px-3 ${
        isMobileWidth
          ? "bg-sky-100"
          : "bg-white/90 backdrop-blur border-b border-slate-200 shadow-sm"
      }`}
      style={isMobileWidth ? { background: colorCode } : undefined}
    >
      <div className="mx-auto max-w-[1400px] h-full flex justify-between items-center gap-2">
        <div className="pl-0 sm:pl-10">
          <NavbarHamburger />
        </div>
        <NavbarLogo />
        <div className="flex items-center gap-2">
          <NavbarInstagramButton />
          <NavbarNotificationBell />
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
